import React, {useCallback, useEffect} from "react";
import {ManuscriptService} from "../../services/manuscript.service";
import {ProposalModel} from "../../models/proposal.model";
import {toggleLoader} from "../../store/global/global-slice";
import {useDispatch} from "react-redux";
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";
import {useParams} from "react-router-dom";
import {ApplicationToSend} from "../../components/author/books/application-to-send";
import {SuccessModal} from "../../components/ui-base/success-modal";
import {ApplicationStatusEnum} from "../../models/application-status.enum";
import {useTranslation} from "react-i18next";

const AuthorPublishersBooksPage = () => {
    const [proposals, setProposals] = React.useState<ProposalModel[]>([]);
    const [openSuccessModal, setOpenSuccessModal] = React.useState(false);
    const [successModalDesc, setSuccessModalDesc] = React.useState('');
    const dispatch = useDispatch();
    const urlParams = useParams();
    const manuscriptId: string = urlParams['id'] as string;
    const { t } = useTranslation('author');

    const loadProposals = useCallback(async () => {
        const proposals = await ManuscriptService.getProposals(manuscriptId, 0, -1, [ApplicationStatusEnum.Created, ApplicationStatusEnum.WithCont, ApplicationStatusEnum.Analyzed]);

        setProposals(proposals);
        dispatch(toggleLoader(false));
    }, [manuscriptId, dispatch]);

    useEffect(() => {
        if (manuscriptId) {
            dispatch(toggleLoader(true));
            loadProposals();
        }
    }, [manuscriptId, dispatch, loadProposals]);

    const submitToPublisher = async (id: number, publisherActive: boolean) => {
        dispatch(toggleLoader(true));
        const submittedToPublisher = await ManuscriptService.submitToPublisher(id);

        if (submittedToPublisher) {
            setSuccessModalDesc((publisherActive) ? t('publishersBooks.sent1') : t('publishersBooks.sent2'));
            setOpenSuccessModal(true);
            loadProposals();
        } else {
            dispatch(toggleLoader(false));
        }
    }

    return (
        <>
            <Grid container direction={"column"} spacing={2}>
                <StyledPrimaryPublishers container item direction={'row'} spacing={2} justifyContent={"center"}>
                    {proposals.map((proposalData) =>
                        <ApplicationToSend key={proposalData.id} proposal={proposalData} submitToPublisher={() => { submitToPublisher(proposalData.id, proposalData.publisher.publisher_type === 'ACTIVE') }}/>
                    )}
                </StyledPrimaryPublishers>
            </Grid>
            <SuccessModal open={openSuccessModal} setOpen={setOpenSuccessModal} title={successModalDesc}/>
        </>
    );
}

const StyledPrimaryPublishers = styled(Grid)`
  //background-color: #fff;
`;

export default AuthorPublishersBooksPage;
